import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import { serviceSegments } from '../mock';
import { ArrowRight, CheckCircle2, Sparkles, Info } from 'lucide-react';
import ItemDetailDialog from './ItemDetailDialog';

export default function ServiceSegments() {
  const [active, setActive] = useState(serviceSegments[0].id);
  const [openKey, setOpenKey] = useState(null);
  const current = serviceSegments.find((s) => s.id === active);
  const Icon = Icons[current.icon] || Icons.Sparkles;

  return (
    <section id="services" className="section bg-white">
      <div className="container-x">
        {/* Boxed header */}
        <div
          className="relative max-w-4xl mx-auto rounded-3xl p-8 sm:p-10 mb-12 text-center overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #E8F5EE 0%, #ffffff 55%, #FFF7EE 100%)',
            border: '2px solid rgba(31,139,76,0.15)',
            boxShadow: '0 10px 40px -20px rgba(31,139,76,0.35)',
          }}
        >
          <div className="absolute -right-14 -top-14 w-40 h-40 rounded-full bg-[color:var(--brand-orange)]/15 blur-2xl" />
          <div className="absolute -left-14 -bottom-14 w-40 h-40 rounded-full bg-[color:var(--brand-green)]/15 blur-2xl" />

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-1.5 rounded-full shadow-sm border border-[color:var(--brand-orange)]/20 mb-4">
              <Sparkles size={14} className="text-[color:var(--brand-orange)]" />
              <span className="text-[11px] font-bold uppercase tracking-[3px] text-[color:var(--brand-orange)]">
                Our Segments
              </span>
            </div>
            <h2 className="section-title">
              Diversified Services, <span className="grad-text">One Trusted Partner</span>
            </h2>
            <p className="section-sub mt-4 mx-auto">
              E-Commerce marketplace management, Social Media growth and Website Development —
              all under one roof.
            </p>
            <p className="mt-3 text-xs font-semibold text-[color:var(--brand-green-dark)]">
              👇 Click any option below to see full details
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {serviceSegments.map((s) => {
            const isActive = s.id === active;
            return (
              <button
                key={s.id}
                onClick={() => setActive(s.id)}
                className={`px-5 py-3 rounded-full text-sm font-semibold transition-all border-2 ${
                  isActive
                    ? 'bg-[color:var(--brand-green)] text-white border-[color:var(--brand-green)] shadow-md'
                    : 'bg-white text-[color:var(--ink)] border-neutral-200 hover:border-[color:var(--brand-green)] hover:text-[color:var(--brand-green)]'
                }`}
              >
                {s.title}
              </button>
            );
          })}
        </div>

        {/* Segment content */}
        <div className="grid lg:grid-cols-2 gap-10 items-center bg-gradient-to-br from-[color:var(--brand-green-light)] to-orange-50/40 rounded-3xl p-8 lg:p-12 border border-neutral-100">
          <div>
            <div className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center shadow-md mb-5 text-[color:var(--brand-green)]">
              <Icon size={30} />
            </div>
            <h3 className="text-3xl font-black text-[color:var(--ink)] mb-2">{current.title}</h3>
            <div className="text-[color:var(--brand-orange)] font-semibold text-sm uppercase tracking-widest mb-4">
              {current.subtitle}
            </div>
            <p className="text-[color:var(--ink-soft)] leading-relaxed mb-6">{current.desc}</p>
            <a href="/contact" className="btn-primary">
              Enquire Now <ArrowRight size={16} />
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-3">
            {current.items.map((it) => (
              <button
                type="button"
                key={it}
                onClick={() => setOpenKey(it)}
                className="group text-left bg-white rounded-xl px-5 py-4 border border-neutral-100 flex items-center gap-3 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[color:var(--brand-green)]/40 transition-all cursor-pointer"
              >
                <CheckCircle2 size={20} className="text-[color:var(--brand-green)] shrink-0" />
                <span className="text-sm font-semibold text-[color:var(--ink)] flex-1">{it}</span>
                <Info size={16} className="text-neutral-400 group-hover:text-[color:var(--brand-green)] transition" />
              </button>
            ))}
          </div>
        </div>
      </div>

      <ItemDetailDialog
        itemKey={openKey}
        open={!!openKey}
        onOpenChange={(v) => !v && setOpenKey(null)}
      />
    </section>
  );
}
